
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 240 240","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 120c.001-55.001 45.001-100 100-100 55 0 100 45 100 100s-45 100-100 100c-54.999 0-99.999-44.999-100-100zm136.5 69H116v23h4c13 0 25.5-2.5 36.5-7.5V189zm8 12v-15.5c0-.5 0-1.5-.5-2 4-4.5 5-10 5-14.5v-24c0-7.5-4.5-22-22-22h-15V98c4-3.5 6.5-9 6.5-14.5 0-10.5-8.5-19-19-19s-19 8.5-19 19c0 5.5 2.5 11 7 14.5v42.5l-6-6c-6-6-16-5-21 0-4 4-5 10.5 2.5 18.5 4 4 13.5 14 21.5 22l2.5 2.5c2 2 3 3.5 3.5 4.5-1.5.5-2.5 2-2.5 3.5v26c-45-6-80-44.5-80-91.5 0-51 41-92 92-92s92 41 92 92c0 35-19 65-47.5 81zM132 130v10c0 2-2 4-4 4s-4-2-4-4V97.5c0-4.5-4-4.5-4.5-4.5-1 0-4.5.5-4.5 4.5V148c8 8 15.5 16 15.5 16 1.5 1.5 1.5 4 0 5.5s-4 1.5-5.5 0c0 0-21.5-22-29-30-3-2.5-8-2-10 0s.5 5.5 2.5 7.5c4 4 13.5 14 21.5 22l2.5 2c3.5 3.5 5.5 6.5 6 9.5h34c4.001-1 8.5-4.001 8.5-12.5v-24c0-1.5-.5-14-14-14h-15zm-46.5-27.5h-30c-2 0-4-2-4-4v-30c0-2 2-4 4-4h30c2.5 0 4 1.5 4 4v30c0 2-2 4-4 4zm99 0h-35c-1.5 0-3-.5-3.5-2s-.5-3 0-4l17.5-30c1-1.5 2-2 3.5-2l.07.001a2.867 2.867 0 01.281.017l.07.008c.144.017.286.042.427.076l.057.013.069.018.068.019c.098.028.195.06.291.095.983.358 1.818 1.055 2.167 1.753l17.5 30c.5 1 1 3 0 4s-2 2-3.5 2zm-103-30h-22v22h22v-22zm95.5 22L166.5 76 156 94.5h21zm-68.5-11c0-6 5-11 11-11s11 5 11 11c0 2-.5 4-1.5 6-2.5-2.5-6-4-9.5-4s-7 1.5-9.5 4c-1-1.5-1.5-4-1.5-6z"}})])
          )
        }
      }
    